<template>
  <v-form ref="form" @keyup.native.enter="submit">
    <v-card class="pa-md-5" elevation="3">
      <v-card-title>
        <v-flex>Reset password</v-flex>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-text-field
            v-model="oldpass"
            :type="show1 ? 'text' : 'password'"
            :append-icon="show1 ? 'visibility' : 'visibility_off'"
            @click:append="show1 = !show1"
            :rules="[() => !!oldpass || 'This field is required']"
            label="Old Password"
            outlined
            required
          ></v-text-field>
          <v-text-field
            v-model="newpass1"
            :type="show2 ? 'text' : 'password'"
            :append-icon="show2 ? 'visibility' : 'visibility_off'"
            @click:append="show2 = !show2"
            :rules="[
              () =>
                oldpass != newpass1 ||
                'This cannot be the same as your old password'
            ]"
            label="New Password"
            outlined
            required
          ></v-text-field>
          <v-text-field
            v-model="newpass2"
            :type="show3 ? 'text' : 'password'"
            :append-icon="show3 ? 'visibility' : 'visibility_off'"
            @click:append="show3 = !show3"
            :rules="[() => newpass1 === newpass2 || 'Not the same as above']"
            label="New Password Confirm"
            outlined
            required
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="submit" large color="primary">Change Password</v-btn>
      </v-card-actions>
      <v-snackbar v-model="snackbar" :timeout="10000" class="text-center">
        {{ snackbarText }}
      </v-snackbar>
    </v-card>
  </v-form>
</template>

<script>
import { auth } from "@/plugins/firebase";
export default {
  data: function() {
    return {
      show1: false,
      show2: false,
      show3: false,
      oldpass: "",
      newpass1: "",
      newpass2: "",
      snackbar: false,
      snackbarText: ""
    };
  },
  methods: {
    submit: function() {
      this.snackbarText = "";
      this.snackbar = false;

      if (this.$refs.form.validate() && this.oldpass) {
        auth
          .signInWithEmailAndPassword(
            this.$store.state.user.email,
            this.oldpass
          )
          .then(() => {
            auth.currentUser
              .updatePassword(this.newpass1)
              .then(() => {
                this.snackbarText = "Successfully changed password";
                this.snackbar = true;
                this.$refs.form.reset();
              })
              .catch(error => {
                this.snackbarText = error;
                this.snackbar = true;
              });
          })
          .catch(error => {
            this.snackbarText = error;
            this.snackbar = true;
          });
      } else {
        this.snackbarText = "Form not filled in";
        this.snackbar = true;
      }
    }
  }
};
</script>